<div>
  <div class="search-row">
    <input
      #inputRef
      [formControl]="searchControl"
      [matAutocomplete]="auto"
      matInput
      placeholder="{{ 'Search_HS_codes_tr' | translate }}"
      data-testid="hscode-input"
      (blur)="onInputBlur()"
    />
    <label class="eudr-filter">
      <span>EUDR</span>
      <mat-checkbox [checked]="showEudrOnly" (change)="toggleEudrOnly($event.checked)"></mat-checkbox>
    </label>
  </div>

  <mat-autocomplete
    #auto="matAutocomplete"
    (optionSelected)="selectHsCode($event.option.value)"
    (closed)="onPanelClosed()"
    [autoActiveFirstOption]="true"
    [displayWith]="displayHsCode"
  >
    @for (hsCode of searchResults | async; track hsCode.code) {
      <mat-option [value]="hsCode">
        <strong>{{ hsCode.code }}</strong>
        {{ hsCode.description }}
        @if (hsCode.tags?.length) {
          <span class="ready-badge">
            @for (tag of hsCode.tags; track tag) {
              <span class="tag-chip">{{ tag }}</span>
            }
          </span>
        }
      </mat-option>
    } @empty {
      @if (searchControl.value && searchControl.value.length >= 2) {
        <mat-option disabled>{{ 'No_HS_codes_found_tr' | translate }}</mat-option>
      }
    }
  </mat-autocomplete>

  @if (selectedHsCode) {
    <div class="detail" tabindex="0" (click)="focusInput($event)">
      <span class="detail-text">
        <strong>{{ selectedHsCode.code }}</strong>
        {{ selectedHsCode.description }}
        @if (selectedHsCode.tags?.length) {
          <span class="ready-badge">
            @for (tag of selectedHsCode.tags; track tag) {
              <span class="tag-chip">{{ tag }}</span>
            }
          </span>
        }
      </span>
      @if (!disabled) {
        <a aria-label="Clear" (click)="clearSelection($event)">
          <mat-icon>close</mat-icon>
        </a>
      }
    </div>
  }
</div>
